export default "__VITE_ASSET__Dp9B4lHH__"